/**
 * 文件上传类型
 */
export default Object.freeze({
    COVER: 1, // 封面图
    HELP: 2, // 使用指引
})